export default {
  statuses: {
    NEW: 'Nouvelle',
    PROCESSING: 'En traitement',
    COMPLETED: 'Terminé',
    FAILED: 'Échec',
  },
}
